var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMin = function SvgIconMin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 2,
    viewBox: "0 0 7 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })));
};
export { SvgIconMin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIyIiB2aWV3Qm94PSIwIDAgNyAyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";